export default __webpack_public_path__ + "locales/lo-LA/Common.json?hash=39d90002848e9accbbe2b3795a3c4d1b";